export const MODALITY_PRODUCT_MAP: { [key: string]: string[] } = {
  'Site Planning Guides': [
    'AT Planning Guides',
    'CT Planning Guides',
    'MI Planning Guides',
    'MR Planning Guides',
    'XP Planning Guides'
  ],
  'AT': [
    'ARTIS genio',
    'ARTIS icono',
    'ARTIS icono.explore',
    'ARTIS one / Soul-Man',
    'ARTIS pheno',
    'Artis Q',
    'Artis zee / zeego',
    'AXIOM Artis',
    'AXIOM Artis U',
    'CorPath GRX',
    'ARCADIS Family',
    'CIARTIC Move',
    'Cios Alpha',
    'Cios Connect',
    'Cios Fit',
    'Cios Fit (ID)',
    'Cios Fit (CN)',
    'Cios Fit FD',
    'Cios Flow',
    'Cios Fusion',
    'Cios Select',
    'Cios Select FD',
    'Cios Spin',
    'MULTIMOBIL 5C',
    'SIREMOBIL Compact / L',
    'SIREMOBIL Compact L',
    'SIREMOBIL Iso-C',
    'Nexaris Angio-CT',
    'NUCLeUS',
    'AXIOM Sensis XP',
    'Sensis / Sensis Lite',
    'Sensis Vibe',
    'SENTICOR Pure',
    'KOORDINAT O.R.',
    'KOORDINAT UB',
    'ANGIOSTAR Plus',
    'AXIOM Multistar/T.O.P./Plus',
    'NEUROSTAR T.O.P./Plus',
    'ACOM.PC',
    'LEONARDO',
    'LEONARDO Workstation',
    'syngo MM WP',
    'syngo X WP / syngo Application Software'
  ],
  'CS': [
    'Application Training Laboratory Diagnostics & Point-of-Care',
    'Application Training Medical Imaging',
    'Australia/New Zealand - Electrical Safety Test',
    'Peru/Ecuador - Requirements for ATS',
    'United Kingdom/Ireland - Critical Examination',
    'CB-DOC Help',
    'Smart Remote Services (SRS)'
  ],
  'CT': [
    'NAEOTOM Alpha / Alpha.Peak / Alpha.Pro',
    'NAEOTOM Alpha SW-Guided Maintenance',
    'NAEOTOM Alpha.Prime',
    'SOMATOM Confidence',
    'SOMATOM Definition',
    'SOMATOM Definition AS',
    'SOMATOM Definition Edge',
    'SOMATOM Definition Flash',
    'SOMATOM Drive',
    'SOMATOM Edge Plus',
    'SOMATOM Emotion (2003)',
    'SOMATOM Emotion (2007 / 2010) / Spirit',
    'SOMATOM Force / Force Velo',
    'SOMATOM go.All / go.Top / go.Fit',
    'SOMATOM go.Now / go.Up',
    'SOMATOM go.Sim / go.OpenPro',
    'SOMATOM On.site V2',
    'SOMATOM Perspective',
    'SOMATOM Pro.Pulse / Pro.Pulse Velo',
    'SOMATOM Scope',
    'SOMATOM Sensation 10/16/40/64',
    'SOMATOM X.ceed',
    'SOMATOM X.cite'
  ],
  'DA': [
    'AI-Rad Companion',
    'BEFUND24',
    'Business Continuity',
    'Desktop Connector',
    'DicomProxy',
    'Digital Pathology Scanning',
    'Edge Platform',
    'eHealth Solutions',
    'MagicLink A',
    'MagicStore',
    'Medicalis Clinical Decision Support',
    'Medicalis Consult Portal',
    'Medicalis Intelligo',
    'Medicalis Referral Management',
    'Medicalis Workflow Orchestrator',
    'Resolution MD',
    'Stroke Connect',
    'Syngo Carbon Business Continuity',
    'Syngo Carbon Container Orchestration',
    'Syngo Carbon Infrastructure Backbone',
    'Syngo Carbon Installer / OS OVAs',
    'Syngo Carbon Monitoring',
    'Syngo Carbon Remote Connect',
    'Syngo Carbon Enterprise Access',
    'Syngo Carbon IDM',
    'Syngo Carbon Intelligo',
    'Syngo Carbon Pathology',
    'Syngo Carbon Space',
    'Syngo Carbon Workflow',
    'syngo Dynamics',
    'syngo Imaging',
    'syngo Portal Executive MLR',
    'syngo Virtual Cockpit',
    'syngo Workflow MLR',
    'syngo Workflow SLR',
    'syngo.plaza',
    'syngo.share',
    'syngo.via',
    'syngo.via View&GO',
    'teamplay',
    'teamplay digital health platform connect',
    'teamplay myCare Companion',
    'TVA',
    'Virtualization Platform'
  ],
  'LS': [
    'Atellica COV',
    'Atellica CI Analyzer',
    'Atellica Solution',
    'CI Max',
    'ADVIA Automation',
    'Aptio by Inpeco',
    'Aptio by Siemens',
    'Atellica TTA (Task Targeted Automation)',
    'Dimension STM',
    'FlexLab High Speed',
    'FlexLab X',
    'StreamLAB Automation Solutions',
    'VersaCell',
    'VersaCell X3',
    'Atellica UAS 60',
    'Atellica UAS 800',
    'CLINITEK Novus',
    'ADVIA 1800',
    'ADVIA 2400',
    'ADVIA Chemistry XPT',
    'Atellica Connectivity Manager',
    'Atellica Data Manager',
    'Atellica Inventory Manager',
    'Atellica Process Manager',
    'Data Management Software (DMS)',
    'PRISCA',
    'syngo Lab Connectivity Manager (LCM)',
    'syngo Lab Data Manager (LDM)',
    'Atellica DT 250',
    'Syva',
    'ADVIA 120/2120/2120i',
    'ADVIA 360',
    'ADVIA 560',
    'Atellica HEMA',
    'CellaVision DM',
    'Hema-Tek 2000',
    'Hema-Tek-3000',
    'Scopio X100/X100HT DCM',
    'Atellica COAG 360 System',
    'BCS XP System',
    'BFT II System',
    'CA-7000 Automation System',
    'CA-1500 System',
    'CA-500 System',
    'CA-600 System',
    'CA-7000 System',
    'CN-3000/CN-6000 Systems',
    'CS-2000i/2100i System',
    'CS-2500 System',
    'CS-5100 System',
    'Hemostasis Applications',
    'PFA-100',
    'PFA-200',
    'ADVIA Centaur CP',
    'ADVIA Centaur XP',
    'ADVIA Centaur XPT',
    'IMMULITE / IMMULITE 1000',
    'IMMULITE 2000/2000 XPi',
    'Dimension EXL',
    'Dimension RMS',
    'Dimension RxL Max',
    'Dimension Vista',
    'Dimension Xpand',
    'Applications PP',
    'Atellica NEPH 630 System',
    'BN II',
    'BN ProSpec',
    'Protis IT Software - aurelio/lab',
    'protis System'
  ],
  'MD': [
    'AutoBlot 3000H',
    'AutoLiPA 48',
    'Tendigo',
    'Tissue Preparation System',
    'VERSANT kPCR'
  ],
  'MI': [
    'Eclipse',
    'Explora',
    'Explora-One',
    'Miraview',
    'syngo MI Workplaces',
    'Biograph 16',
    'Biograph 16 TruePoint',
    'Biograph 40/64 Truepoint',
    'Biograph 6',
    'Biograph 6 Truepoint',
    'Biograph Classic/Duo',
    'Biograph Horizon',
    'Biograph mCT Flow',
    'Biograph Trinion',
    'Biograph Vision',
    'Biograph Vision Quadra',
    'ECAT',
    'Inveon Dedicated PET',
    'Inveon Multimodality',
    'microPET Focus',
    'c.cam',
    'e.cam',
    'Symbia E',
    'Symbia Evo',
    'Symbia Evo Excel',
    'Symbia Intevo',
    'Symbia Pro.specta',
    'Symbia S',
    'Symbia T'
  ],
  'MR': [
    'Biograph mMR',
    'BIOGRAPH One',
    'MAGNETOM Concerto syngo MR',
    'MAGNETOM Harmony',
    'MAGNETOM Harmony syngo MR',
    'Helium Provider',
    'MAGNETOM Impact / Impact plus',
    'MAGNETOM Impact Expert / Impact Expert plus',
    'MAGNETOM Jazz',
    'MAGNETOM 7T / 7T Plus',
    'MAGNETOM Aera',
    'MAGNETOM Altea',
    'MAGNETOM Amira',
    'MAGNETOM Avanto',
    'MAGNETOM Avanto fit',
    'MAGNETOM Avanto Fit BioMatrix',
    'MAGNETOM C!',
    'MAGNETOM Cima.X / Cima.X SCI',
    'MAGNETOM Cima.X Fit',
    'MAGNETOM Espree',
    'MAGNETOM ESSENZA',
    'MAGNETOM Flow. Platform, including Flow.Ace / Flow.Plus',
    'MAGNETOM Free.Max / Free.Star',
    'MAGNETOM Free.XL',
    'MAGNETOM Luban',
    'MAGNETOM Lumina / Seara',
    'MAGNETOM OR - Table',
    'MAGNETOM Prisma / Prisma fit',
    'MAGNETOM Sempra, Mica',
    'MAGNETOM Skyra',
    'MAGNETOM Skyra fit',
    'MAGNETOM Skyra Fit BioMatrix',
    'MAGNETOM Sola',
    'MAGNETOM Sola Fit',
    'MAGNETOM Spectra',
    'MAGNETOM Symphony, A Tim System',
    'MAGNETOM Symphony syngo MR',
    'MAGNETOM Terra',
    'MAGNETOM Terra.X',
    'MAGNETOM Trio',
    'MAGNETOM Trio, A Tim System',
    'MAGNETOM Verio',
    'MAGNETOM Viato.Mobile',
    'MAGNETOM Vida',
    'MAGNETOM Vida Fit',
    'Open / Open viva',
    'Open viva #P',
    'MAGNETOM Sonata',
    'MAGNETOM Sonata syngo MR',
    'MAGNETOM Symphony',
    'MAGNETOM Vision'
  ],
  'OEM': [
    'OEM Collimators / Buckys',
    'OEM Generators',
    'POLYDOROS A100Plus',
    'POLYDOROS IT 30/55-65/80',
    'POLYDOROS LX 30/50Lite/80',
    'OEM Radiographic Subsystems',
    '3D TOP (OEM)',
    'RAD TC (OEM)',
    'RAD TF (OEM)',
    'VERTIX P (OEM)',
    'VERTIX T (OEM)'
  ],
  'POC': [
    'RAPIDChem 744/754',
    'epoc Blood Analysis System',
    'RAPIDLab 1200',
    'RAPIDLab 248',
    'RAPIDLab 348',
    'RAPIDLab 348EX',
    'RAPIDLab 800',
    'RAPIDPoint 300',
    'RAPIDPoint 400',
    'RAPIDPoint 500/500e',
    'Atellica VTLi Immunoassay Analyzer',
    'Xprecia Stride',
    'Atellica DCA',
    'DCA 2000',
    'DCA Vantage',
    'Atellica Connect POC Insights',
    'dNote',
    'epoc Enterprise Data Manager',
    'Meditrac',
    'POCcelerator Data Manager System',
    'RAPIDComm',
    'UniPOC',
    'Stratus CS',
    'Stratus CS 200',
    'Atellica LumIQ',
    'CLINITEK 50',
    'CLINITEK 500',
    'CLINITEK Advantus',
    'CLINITEK Atlas',
    'CLINITEK AUWi',
    'CLINITEK AUWi PRO',
    'CLINITEK Status'
  ],
  'PT': [
    'HIT Beam Application Monitoring',
    'HIT General and Safety',
    'HIT IONTRIS IT',
    'HIT IONTRIS Precision',
    'HIT IONTRIS QA',
    'HIT Safety and Control System',
    'MIT Beam Application Monitoring',
    'MIT General and Safety',
    'MIT Infrastructure Safety System',
    'MIT IONTRIS Acceleration',
    'MIT IONTRIS IT',
    'MIT IONTRIS Precision',
    'MIT IONTRIS QA',
    'MIT Mechanical Systems Facility',
    'MIT Monitor Gas System',
    'MIT PT Injector',
    'MIT Safety and Control System',
    'MAR Infrastructure Safety System (GmbH)',
    'MAR IONTRIS Acceleration (GmbH)',
    'MAR IONTRIS IT (GmbH)',
    'MAR IONTRIS QA (GmbH)',
    'MAR Mechanical Systems Facility (GmbH)',
    'MAR Monitor Gas System (GmbH)',
    'MAR PT Injector (GmbH)',
    'SHA Beam Application Monitoring',
    'SHA Facility Auxiliaries',
    'SHA General and Safety',
    'SHA Infrastructure Safety System',
    'SHA IONTRIS Acceleration',
    'SHA IONTRIS IT',
    'SHA IONTRIS Precision',
    'SHA IONTRIS QA',
    'SHA Monitor Gas System',
    'SHA PT Injector',
    'SHA Safety and Control System',
    'CNAO Server and Hardware'
  ],
  'RO': [
    'Artiste Linear Accelerator',
    'ONCOR Linear Accelerator',
    'PRIMUS Linear Accelerator',
    'CANDELIS',
    'LANTIS',
    'MOSAIQ',
    'SIMVIEW / MEVASIM S',
    'Coherence WS / syngo RT'
  ],
  'US': [
    'ACUSON Bonsai',
    'ACUSON CV70',
    'ACUSON Cypress',
    'ACUSON Freestyle',
    'ACUSON Juniper',
    'ACUSON Maple',
    'ACUSON NX2',
    'ACUSON NX3',
    'ACUSON OMNI 1',
    'ACUSON OMNI 3/5',
    'ACUSON P300',
    'ACUSON P50',
    'ACUSON P500',
    'ACUSON Redwood',
    'ACUSON S1000',
    'ACUSON S2000',
    'ACUSON S3000',
    'ACUSON SC2000',
    'ACUSON Sequoia',
    'ACUSON Sequoia ST / ACUSON Origin',
    'ACUSON X150',
    'ACUSON X300',
    'ACUSON X600',
    'ACUSON X700',
    'Remote Connectivity Solution',
    'syngo Ultrasound Apps Suite',
    'syngo Ultrasound Breast Analysis',
    'ACUSON & SONOLINE Antares',
    'SONOLINE G20',
    'SONOLINE G40',
    'SONOLINE G50/G60S',
    'SONOLINE G60S r10.0',
    'SONOVISTA FX',
    'SONOVISTA FX PE',
    'syngo Ultrasound Workplace',
    'syngo.fourSight Workplace'
  ],
  'XP': [
    'AXIOM Iconos MD',
    'AXIOM Iconos R100',
    'AXIOM Iconos R100 (RHD)',
    'AXIOM Iconos R200',
    'AXIOM Iconos R200 ND',
    'AXIOM Luminos dRF',
    'AXIOM Luminos TF',
    'AXIOM Sireskop SD',
    'AXIOM SIRESKOP SX/SD',
    'Luminos Agile',
    'Luminos Agile Max',
    'Luminos dRF Max',
    'Luminos Fusion',
    'Luminos Impulse',
    'LUMINOS Lotus Max',
    'LUMINOS Q.namix R',
    'LUMINOS Q.namix T',
    'Luminos RF Classic',
    'Luminos Select',
    'LITHOSKOP',
    'MODULARIS Uro Plus',
    'UROSKOP ACCESS',
    'UROSKOP Omnia',
    'Uroskop Omnia Max',
    'ABVS-Workplace',
    'MAMMOMAT 1000/3000',
    'MAMMOMAT B.brilliant',
    'MAMMOMAT B.ready',
    'MAMMOMAT Balance',
    'MAMMOMAT Fusion',
    'MAMMOMAT Inspiration',
    'MAMMOMAT Revelation',
    'MAMMOMAT SELECT',
    'syngo MammoReport',
    'TransScan TS2000',
    'MOBILETT Elara Max',
    'MOBILETT Impact',
    'Mobilett Mira Max',
    'Mobilett Mira wireless/ wired',
    'MOBILETT Tuna',
    'MOBILETT XP CR',
    'MOBILETT XP Digital',
    'MOBILETT XP (Hybrid / Eco)',
    'MULTIMOBIL 10 / Zebra',
    'MULTIMOBIL 2.5',
    'POLYMOBIL III',
    'POLYMOBIL PLUS',
    'AXIOM Aristos FX/FX Plus',
    'AXIOM Aristos MX/VX/VXPlus',
    'AXIOM Aristos TX',
    'AXIOM Multix M',
    'AXIOM Vertix MD Trauma',
    'AXIOM Vertix Solitaire M',
    'MULTIX Focus',
    'Multix Fusion (Analog)',
    'Multix Fusion (Digital)',
    'Multix Fusion Max',
    'Multix Impact',
    'Multix Impact C',
    'Multix Impact E',
    'MULTIX PRO',
    'MULTIX Select DR',
    'MULTIX Swing',
    'MULTIX TOP',
    'VERTIX Solitaire',
    'Ysio',
    'Ysio Max',
    'YSIO X.pree',
    'YSIO X.pree Gen2',
    'Multitom Rax'
  ]
};
